export default function RouteLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background-50 px-4">
      <div className="rounded-2xl border border-background-200 bg-white px-6 py-5 text-center shadow-sm">
        <div className="mx-auto mb-3 h-9 w-9 animate-spin rounded-full border-2 border-primary-100 border-t-primary-500" />
        <p className="text-sm font-medium text-foreground-700">正在加载页面...</p>
        <p className="mt-1 text-xs text-foreground-400">智选志愿为你准备内容</p>
      </div>
    </div>
  );
}
